import { useQuery } from 'react-query';
import { CCWorkflowsApi } from '../api/ccWorkflows';
import { fetchAllPages } from '../utils/pagination';

export const useAllCCWorkflows = (companyId: number, itemId: number, enabled = true) => {
  return useQuery({
    queryFn: () =>
      fetchAllPages((offset, limit) =>
        CCWorkflowsApi.fetchCCWorkflowsPage(companyId, itemId, { offset, limit, includeNotLinked: true }),
      ),
    queryKey: ['cc_workflows_all', companyId, itemId],
    refetchOnWindowFocus: false,
    enabled,
  });
};
